import { DeleteArcgisCivil3dFeatureLineSettingsApiRequest } from 'types/requests/arcgis-civil3d-settings/feature-lines/delete-arcgis-civil3d-feature-line-settings.request';
import { ArcgisCivil3dFeatureLineSettingApiModel } from '../../../types/models/arcgis-civil3d-feature-line-setting.model';
import { CreateArcgisCivil3dFeatureLineSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/create-arcgis-civil3d-feature-line-setting.request';
import { GetArcgisCivil3dFeatureLineSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/get-arcgis-civil3d-feature-line-settings.request';
import { SearchArcgisCivil3dFeatureLineSettingsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/search-arcgis-civil3d-feature-line-settings.request';
import { UpdateArcgisCivil3dFeatureLineSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/update-arcgis-civil3d-feature-line-setting.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { ArcgisCivil3dPropertyMappingApiModel } from '../../../types/models/arcgis-civil3d-property-mapping.model';
import { CreatePropertyMappingForFeatureLineApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/create-property-mapping-for-feature-line.request';
import { DeletePropertyMappingForFeatureLineApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/delete-property-mapping-for-feature-line.request';
import { GetAllPropertyMappingsForFeatureLineApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/get-all-property-mappings-for-feature-line.request';
import { UpdatePropertyMappingsForFeatureLineApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/update-property-mappings-for-feature-line.request';
import { DuplicateArcgisCivil3dFeatureLineSettingsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/duplicate-arcgis-civil3d-feature-line-settings.request';
import { CreatePropertyMappingsForFeatureLinesApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/create-property-mappings-for-feature-lines.request';
import { SearchPropertyMappingsForFeatureLinesApiRequest } from '../../../types/requests/arcgis-civil3d-settings/feature-lines/search-property-mappings-for-feature-lines.request';

export const createFeatureLineSetting = (params: CreateArcgisCivil3dFeatureLineSettingApiRequest) =>
  client.post<ArcgisCivil3dFeatureLineSettingApiModel>('/arcgis-civil3d-settings/feature-lines', params);

export const updateFeatureLineSetting = ({
  featureLineId,
  ...params
}: UpdateArcgisCivil3dFeatureLineSettingApiRequest) =>
  client.patch<ArcgisCivil3dFeatureLineSettingApiModel>(
    `/arcgis-civil3d-settings/feature-lines/${featureLineId}`,
    params,
  );

export const deleteFeatureLineSettings = ({
  featureLineIds,
  ...params
}: DeleteArcgisCivil3dFeatureLineSettingsApiRequest) =>
  client.delete<ArcgisCivil3dFeatureLineSettingApiModel>(`/arcgis-civil3d-settings/feature-lines`, {
    data: { featureLineIds },
    ...params,
  });

export const duplicateFeatureLineSettings = (params: DuplicateArcgisCivil3dFeatureLineSettingsApiRequest) =>
  client.post<ArcgisCivil3dFeatureLineSettingApiModel[]>(`/arcgis-civil3d-settings/feature-lines/duplicate`, params);

export const getFeatureLineSetting = <T extends ArcgisCivil3dFeatureLineSettingApiModel>({
  featureLineId,
  ...params
}: GetArcgisCivil3dFeatureLineSettingApiRequest) =>
  client.get<T>(`/arcgis-civil3d-settings/feature-lines/${featureLineId}`, { params });

export const searchFeatureLineSettings = <T extends ArcgisCivil3dFeatureLineSettingApiModel>(
  params: SearchArcgisCivil3dFeatureLineSettingsApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/feature-lines`, { params });

export const createPropertyMappingForFeatureLine = ({
  featureLineId,
  ...params
}: CreatePropertyMappingForFeatureLineApiRequest) =>
  client.post<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/feature-lines/${featureLineId}/property-mappings`,
    { params },
  );

export const searchPropertyMappingsForFeatureLines = <T extends ArcgisCivil3dPropertyMappingApiModel>(
  params: SearchPropertyMappingsForFeatureLinesApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/feature-lines/property-mappings`, { params });

export const createPropertyMappingsForFeatureLines = (params: CreatePropertyMappingsForFeatureLinesApiRequest) =>
  client.post<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/feature-lines/property-mappings`,
    params,
  );

export const updatePropertyMappingsForFeatureLine = ({
  featureLineId,
  ...params
}: UpdatePropertyMappingsForFeatureLineApiRequest) =>
  client.patch<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/feature-lines/${featureLineId}/property-mappings`,
    params,
  );

export const getAllPropertyMappingsForFeatureLine = ({
  featureLineId,
}: GetAllPropertyMappingsForFeatureLineApiRequest) =>
  client.get<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/feature-lines/${featureLineId}/property-mappings`,
  );

export const deletePropertyMappingFromFeatureLine = ({
  featureLineId,
  civil3dPropertyId,
}: DeletePropertyMappingForFeatureLineApiRequest) =>
  client.delete<void>(`/arcgis-civil3d-settings/feature-lines/${featureLineId}/property-mappings/${civil3dPropertyId}`);
